module.exports = __webpack_public_path__ + "static/media/YM88_2.bdcf82ad.jpg";